export const UNASSIGNED_RESOURCE_ID = '__unassigned__'
